var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51031 8.96924C4.5852 11.9686 6.99027 14.5934 9.9906 14.5934V14.5934V14.5934C13.038 14.5934 15.3858 12.011 15.4694 8.9647C15.4797 8.59007 15.4851 8.21269 15.4851 7.83259C15.4851 6.03621 15.3757 4.28005 15.19 2.61695C15.1224 2.01141 14.6665 1.52137 14.0655 1.42093C12.7484 1.20082 11.3968 1.07178 9.9906 1.07178C8.5813 1.07178 7.20521 1.19327 5.8939 1.41749C5.30332 1.51848 4.85686 2.00047 4.78832 2.59568C4.5965 4.26137 4.49609 6.02958 4.49609 7.83259C4.49609 8.21433 4.50092 8.5932 4.51031 8.96924Z",
    fill: "#84C70D",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51031 8.96924C4.5852 11.9686 6.99027 14.5934 9.9906 14.5934V14.5934V14.5934C13.038 14.5934 15.3858 12.011 15.4694 8.9647C15.4797 8.59007 15.4851 8.21269 15.4851 7.83259C15.4851 6.03621 15.3757 4.28005 15.19 2.61695C15.1224 2.01141 14.6665 1.52137 14.0655 1.42093C12.7484 1.20082 11.3968 1.07178 9.9906 1.07178C8.5813 1.07178 7.20521 1.19327 5.8939 1.41749C5.30332 1.51848 4.85686 2.00047 4.78832 2.59568C4.5965 4.26137 4.49609 6.02958 4.49609 7.83259C4.49609 8.21433 4.50092 8.5932 4.51031 8.96924Z",
    stroke: "#84C70D",
    strokeWidth: 1.43
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99219 14.604V18.9288",
    stroke: "#84C70D",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 18.9287H13.4306",
    stroke: "#84C70D",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1445 2.44531H17.4934C18.2824 2.44531 18.922 3.08491 18.922 3.87388V4.12615C18.922 5.46351 18.4878 6.7461 17.715 7.69176C17.1053 8.43791 16.3241 8.92607 15.4847 9.09884",
    stroke: "#84C70D",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80469 2.44531H2.50408C1.7151 2.44531 1.07551 3.08491 1.07551 3.87388V4.12615C1.07551 5.46352 1.50967 6.7461 2.28248 7.69176C2.88889 8.43379 3.66484 8.92068 4.49891 9.09595",
    stroke: "#84C70D",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCup);
export default __webpack_public_path__ + "static/media/small-cup.0640ea4845e2524c0f86e1706a8ff3c5.svg";
export { ForwardRef as ReactComponent };